import classNames from 'classnames';

export const GetNodeClassNames = (node, classes, isNavRefresh) => {
  const classNameList = [
    classes.baseMenuItem,
  ];

  if (!isNavRefresh) {
    classNameList.push(classes.darkBaseMenuItem);
  }

  if (node.isSelected) {
    classNameList.push('selected');
    classNameList.push(classes.selectedMenuItem);
    if (!isNavRefresh) {
      classNameList.push(classes.darkSelectedMenuItem);
    }
  } else if (!isNavRefresh) {
    classNameList.push(classes.normalMenuItem);
  }

  classNameList.push(`menu-item-${node.Id}`);

  return classNames(classNameList);
};

export const abbreviateDynamicItemName = (dynamicItemName) => {
  if (dynamicItemName === null || dynamicItemName.length <= 2) {
    return dynamicItemName;
  }

  const splitDynamicItemName = dynamicItemName.split(' ');
  if (splitDynamicItemName.length < 2) {
    return dynamicItemName.slice(0, 2);
  }
  return splitDynamicItemName.reduce((response, word) => response + word.slice(0, 1), '').slice(0, 2);
};
